import { h, Ref } from 'preact'
import { forwardRef } from 'preact/compat'

import { SelectProps } from 'components/ui/Select/type'
import { Option } from './components'
import Input from '../OtherChoiceInput'

import style from './inlineSelect.scss'
import useSelectProps from 'components/ui/Select/hooks/useSelectProps'
import { useContext, useMemo } from 'preact/hooks'
import FieldsContext from 'components/business/SurveyForm/Fields/fieldsContext'
import { ChoicesSize } from 'scripts/type'
import cn from 'classnames'

const Select = (props: SelectProps, ref?: Ref<HTMLDivElement>) => {
  const { isMultipleFields } = useContext(FieldsContext)!
  const {
    otherChoiceIsChecked,
    showOtherChoiceInput,
    type,
    className,
    checkedOptions,
    options,
    optionRef,
    handleOptionChange,
    handleOtherValueChange,
    displayOrder,
    min,
    max,
  } = useSelectProps(props)

  const isSmall = props.choicesSize === ChoicesSize.Small

  const paddingBottom = useMemo(() => {
    if (isMultipleFields) {
      return 0
    }
    if (otherChoiceIsChecked) {
      return 16
    }
    return 8
  }, [isMultipleFields, otherChoiceIsChecked])

  const disabled = useMemo(() => {
    return !!(max && (checkedOptions?.length ?? 0) >= max)
  }, [checkedOptions, max])

  return (
    <div className={className} ref={ref}>
      <div ref={optionRef} style={{ paddingBottom }}>
        <div className={style.wrap}>
          {displayOrder.map((optionIndex) => {
            const option = options[optionIndex]
            const checked = checkedOptions?.includes(option.value)
            if (!option.label) {
              return null
            }
            return (
              <Option
                disabled={!checked && disabled}
                key={option.value}
                checked={checked}
                value={option.value}
                type={type}
                onChange={(value: string, checked: boolean) => handleOptionChange(value, checked, option.type)}
                choicesSize={props.choicesSize}
                rowChoiceCount={props.rowChoiceCount}
              >
                {option.label}
              </Option>
            )
          })}
        </div>
        {showOtherChoiceInput && (
          <Input className={cn(style.otherInput, isSmall && style.smallOtherInput)} onChange={handleOtherValueChange} />
        )}
      </div>
    </div>
  )
}

export default forwardRef(Select)
